import { render, staticRenderFns } from "./OrdersFBMTableUserTable.vue?vue&type=template&id=1064dfa4&scoped=true"
import script from "./OrdersFBMTableUserTable.vue?vue&type=script&lang=js"
export * from "./OrdersFBMTableUserTable.vue?vue&type=script&lang=js"
import style0 from "./OrdersFBMTableUserTable.vue?vue&type=style&index=0&id=1064dfa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1064dfa4",
  null
  
)

export default component.exports